<template>
	<div class="g-edit-list-sort-group" v-bind="$attrs" @dragover.prevent="$emit('dragover', $event)" @drop="$emit('drop', $event)">
		<slot />
	</div>
</template>

<script>
	export default {
		name: 'GEditListSortGroup',
		inheritAttrs: false,
	};
</script>

<style lang="less">
	@import '../styles/edit-list-drag-sort.less';
</style>
